export default function () {
  const banner = $('.banner.fixed-top, .banner.sticky-top').first();
  const halfViewportHeight =
    banner.outerHeight() + (window.innerHeight - banner.outerHeight()) / 2;

  if ({}.hasOwnProperty.call(window, 'wpcf7')) {
    document.querySelectorAll('.wpcf7 > form.init').forEach((form) => {
      form.classList.remove('init');
      form.replaceWith(form.cloneNode(true));
    });

    document.querySelectorAll('.wpcf7 > form:not(.init)').forEach((form) => {
      try {
        wpcf7.init(form);
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
      }

      /* Validation Events for changing response CSS classes */
      form.addEventListener(
        'wpcf7invalid',
        (event) => {
          $(event.target)
            .find('.wpcf7-response-output')
            .fadeIn()
            .not('.alert-warning')
            .not('.alert-success')
            .addClass('alert alert-danger mt-2');
          event.detail.apiResponse.invalid_fields.forEach((invalidField) => {
            const invalidInputs = event.target.querySelector(
              `#${invalidField.idref}`
            );
            invalidInputs.classList.add('is-invalid');
          });

          // show first failing field
          const firstInvalidField = $(
            `#${event.detail.apiResponse.invalid_fields[0].idref}`
          );

          $([document.documentElement, document.body]).animate(
            {
              scrollTop:
                firstInvalidField.offset().top -
                halfViewportHeight +
                firstInvalidField.height(),
            },
            100
          );
        },
        false
      );
      form.addEventListener(
        'wpcf7spam',
        (event) => {
          $(event.target)
            .find('.wpcf7-response-output')
            .fadeIn()
            .not('.alert-danger')
            .not('.alert-success')
            .addClass('alert alert-warning mt-2');
        },
        false
      );
      form.addEventListener(
        'wpcf7mailfailed',
        (event) => {
          $(event.target)
            .find('.wpcf7-response-output')
            .fadeIn()
            .not('.alert-danger')
            .not('.alert-success')
            .addClass('alert alert-warning mt-2');

          // show first failing field
          $([document.documentElement, document.body]).animate(
            {
              scrollTop:
                $(
                  `#${event.detail.apiResponse.invalid_fields[0].idref}`
                ).offset().top - halfViewportHeight,
            },
            100
          );
        },
        false
      );
      form.addEventListener(
        'wpcf7mailsent',
        (event) => {
          $(event.target)
            .find('.wpcf7-response-output')
            .fadeIn()
            .not('.alert-danger')
            .not('.alert-warning')
            .addClass('alert alert-success mt-2');
          // show success message in the middle of viewport
          const el = event.target.querySelector('.wpcf7-response-output');
          $('html, body').animate(
            {
              scrollTop: el.offsetTop - halfViewportHeight,
            },
            100
          );
        },
        false
      );

      form.addEventListener('wpcf7submit', (event) => {
        $(event.target).find('.wpcf7-submit').removeClass('loading');
      });
    });
  }

  $('.wpcf7-submit').on('click', function () {
    $(this).addClass('loading');
    const form = $(this).closest('.wpcf7');
    form.find('.wpcf7-response-output').hide(0, function () {
      $(this).removeClass(
        'alert alert-danger alert-warning alert-success mt-2'
      );
    });

    form.find('input').removeClass('is-valid is-invalid');
    form.find('.wpcf7-not-valid-tip').remove();
  });
}
